import { BrowserRouter } from "react-router-dom";
import "./App.css";
import Navigation from "./navigation/navigation";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { ConfigProvider } from "antd";

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#FF66B2", // Your primary color
          fontFamily: "Roboto, sans-serif",
        },
      }}
    >
      <BrowserRouter>
        <>
          <Navigation />
          <ToastContainer />
        </>
      </BrowserRouter>
    </ConfigProvider>
  );
}

export default App;
